import type { Coordinates } from '$lib/components/map/types';
import type { BeforeNavigate } from '@sveltejs/kit';

export interface TrackSearchExtensionParams {
	touchpoint?: SearchExtensionTouchpoint;
	navigation?: BeforeNavigate;
	hasContext: boolean;
	isUpdated: boolean;
}

export interface SearchExtensionContextCoreContent {
	address?: string;
	coordinates?: Coordinates;
}

export type SearchExtensionContextContent = SearchExtensionContextCoreContent & {
	updateCount: number;
};

export const SEARCH_EXTENSION_TOUCHPOINT = [
	'autocomplete',
	'compute',
	'itinerary_details',
	'itinerary_result',
	'itinerary_edit',
	'map_add_step_compute',
	'poilist_click',
	'poimap_click',
	'searchbar_compute',
] as const;

export type SearchExtensionTouchpoint = (typeof SEARCH_EXTENSION_TOUCHPOINT)[number];
